import { Box, Modal, Typography, styled } from '@mui/material';
import { TabsList as BaseTabsList } from '@mui/base/TabsList';
import { TabPanel } from '@mui/base/TabPanel';
import { Tab as BaseTab, tabClasses } from '@mui/base/Tab';
import { Tabs } from '@mui/base/Tabs';
import { buttonClasses } from '@mui/base/Button';
import { useState } from 'react';
import BridgeInputGroup from '../bridge/BridgeInputGroup';
import BridgeHistory from '../bridge/BridgeHistory';

interface Props {
  open: boolean;
  onClose: () => void;
}

const TABS = {
  DEPOSIT: 0,
  WITHDRAW: 1,
  HISTORY: 2,
};

const Tab = styled(BaseTab)`
  font-family: 'Koho';
  cursor: pointer;
  font-size: 1rem;
  font-weight: 600;
  width: 100%;
  padding: 0.7rem 1rem;
  margin: 6px;
  border: none;
  border-radius: 7px;
  display: flex;
  justify-content: center;
  color: #9f9f9f;
  background-color: transparent;

  &:hover {
    background-color: #f0fcfe;
  }

  &:focus {
    color: #1d818f;
  }

  &.${tabClasses.selected} {
    background-color: #f0fcfe;
    color: #1d818f;
  }

  &.${buttonClasses.disabled} {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

const TabsList = styled(BaseTabsList)(
  () => `
  min-width: 400px;
  border-radius: 12px;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  align-content: space-between;
  color: #404040,
  `
);

const BridgeModal: React.FC<Props> = (props) => {
  const [isLoading, setIsLoading] = useState<boolean>(false);

  return (
    <Modal
      open={props.open}
      onClose={() => (!isLoading ? props.onClose() : '')}
    >
      <Box
        position="absolute"
        top="50%"
        left="50%"
        padding={4}
        borderRadius={2}
        sx={{
          transform: 'translate(-50%, -50%)',
          background: '#fff',
          width: '100%',
          maxWidth: {
            xs: '80%',
            sm: '80%',
            md: 500,
          },
        }}
      >
        <Typography fontWeight="bold" fontSize={20} mb={2}>
          Bridge VIRTUAL
        </Typography>
        <Typography mb={2}>
          The VIRTUAL ecosystem runs on Base and to participate in it, you'll
          need to bridge your $VIRTUAL to Base.
        </Typography>
        <Typography mb={2}>
          By participating in the ecosystem, you help develop better AI as well
          as earning rewards!
        </Typography>
        <Typography mb={2}>
          Bridging token from Base to Etheruem will take ~7 days to finalize.
        </Typography>

        <Tabs defaultValue={TABS.DEPOSIT}>
          <TabsList>
            <Tab disabled={isLoading} value={TABS.DEPOSIT}>
              Deposit
            </Tab>
            <Tab disabled={isLoading} value={TABS.WITHDRAW}>
              Withdraw
            </Tab>
            <Tab disabled={isLoading} value={TABS.HISTORY}>
              History
            </Tab>
          </TabsList>
          <TabPanel value={TABS.DEPOSIT}>
            <BridgeInputGroup isLoading={setIsLoading} type="deposit" />
          </TabPanel>
          <TabPanel value={TABS.WITHDRAW}>
            <BridgeInputGroup isLoading={setIsLoading} type="withdraw" />
          </TabPanel>
          <TabPanel value={TABS.HISTORY}>
            <BridgeHistory isLoading={setIsLoading} />
          </TabPanel>
        </Tabs>
      </Box>
    </Modal>
  );
};

export default BridgeModal;
